// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Logo40PC_HorizontalDe from './Logo40PC_HorizontalDe.tsx';
import Logo40PC_HorizontalEn from './Logo40PC_HorizontalEn.tsx';
import Logo40PC_HorizontalEs from './Logo40PC_HorizontalEs.tsx';
import Logo40PC_HorizontalFr from './Logo40PC_HorizontalFr.tsx';
import Logo40PC_HorizontalIt from './Logo40PC_HorizontalIt.tsx';

type LogoProps = {
    variation:
        | '40PC_HorizontalDe'
        | '40PC_HorizontalEn'
        | '40PC_HorizontalEs'
        | '40PC_HorizontalFr'
        | '40PC_HorizontalIt';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Logo40PC_HorizontalDe,
    Logo40PC_HorizontalEn,
    Logo40PC_HorizontalEs,
    Logo40PC_HorizontalFr,
    Logo40PC_HorizontalIt,
};

const Logo: FC<LogoProps> = ({ variation, ...props }) => {
    const variationKey = `Logo${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Logo" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Logo;
